
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/4-year-old-tantrums",
      function () {
        return require("private-next-pages/blog/4-year-old-tantrums.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/4-year-old-tantrums"])
      });
    }
  